// extracted by mini-css-extract-plugin
export var bodySections = "_bi-8";
export var gray = "_bi-7";
export var green = "_bi-4";
export var iconContainer = "_bi-9";
export var iconWidgetContainer = "_bi-1";
export var phoneIcon = "_bi-2";
export var red = "_bi-5";
export var statusDot = "_bi-3";
export var widgetContainer = "_bi-0";
export var yellow = "_bi-6";